import { Image } from 'shared';
import Box from 'shared_DEPRECATED/components/Box/Box';
import { FileDownloadButton } from 'shared_DEPRECATED/components/File';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import Spacer from 'shared_DEPRECATED/components/Spacer/Spacer';

import { ModalBody, ModalHeader } from 'shared/components/Modal';
import { Typography } from 'shared/components/Typography';

type TChatMessageImageModal = {
  url: string;
  name: string;
  contentType: string;
};

export default function ChatMessageImageModal({
  url,
  name,
  contentType,
}: TChatMessageImageModal) {
  return (
    <>
      <ModalHeader>
        <Box style={{ width: '90%' }}>
          <Flex justifyContent="space-between" alignItems="center">
            <Typography as="h3" type="body" fontWeight="semibold" color="black">
              Preview image
            </Typography>
            <>
              <Spacer size="xsm" />
              <FileDownloadButton url={url} />
            </>
          </Flex>
        </Box>
      </ModalHeader>
      <ModalBody>
        <Image
          src={url}
          alt={name}
          borderRadius={4}
          contentType={contentType}
          data-testid="chat-message-image-modal-content"
        />
      </ModalBody>
    </>
  );
}
